import { Component, OnInit, ViewContainerRef, ElementRef, ViewChild } from '@angular/core';
import { Entity } from '../Classes/EntityClass';
import { CommonSearch } from '../Classes/CommonClass';
import { CommonService } from '../Services/CommonServices';
import { EntityService } from '../Services/EntityService';
import { Route, Router, ActivatedRoute } from '@angular/router';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Observable } from 'rxjs';
import { Headers, Http, Response, RequestOptions } from '@angular/http';
import * as _ from 'underscore';
@Component({
  selector: 'Entity-Search',
  templateUrl: '../Entity/EntitySearch.component.html',
  styleUrls: ['../../Content/css/bootstrap.css', '../../Content/css/custom.css', '../../Content/css/master.css', '../../Content/css/innflow-top-menu.css',
    '../../Content/css/innflow-main.css', '../../Content/css/fixedheader.css'],
  providers: [CommonService, EntityService]
})

export class EntitySearchComponent implements OnInit {
  _Entity = new Entity();
  _CommonSearch = new CommonSearch();
  innerWidth: number;
  tableRowWidth: number=99;
  loading: boolean = false;

  Loaderimage: string = '../../assets/images/ajax-loader3.gif';
 
  _displaypropertyname1: string = "";
  _displaypropertyname2: string = "";
  _SelectedText_1: string = "";
  _SelectedText_2: string = "";
  _SearchParm: string;
  pagedItems: any[];
  pager: any = {};




  SearchdropFirst: any[] = [
    { Value: 'EntityID', Text: 'EntityID' },
    { Value: 'EntityCode', Text: 'Entity Code' },
    { Value: 'TenantID', Text: 'TenantID' },
    { Value: 'OrgCode', Text: 'Org Code' },
    { Value: 'OrgName', Text: 'Org Name' },
    { Value: 'EntityCity', Text: 'City' },
    { Value: 'EntityState', Text: 'State' },
    { Value: 'Status', Text: 'Status' },
    { Value: 'Franchise', Text: 'Franchise'},
    { Value: 'Brand', Text: 'Brand' }
  ]
  SearchdropSecond: any[] = [
    { Value: 'EntityID', Text: 'EntityID' },
    { Value: 'EntityCode', Text: 'Entity Code' },
    { Value: 'TenantID', Text: 'TenantID' },
    { Value: 'OrgCode', Text: 'Org Code' },
    { Value: 'OrgName', Text: 'Org Name' },
    { Value: 'EntityCity', Text: 'City' },
    { Value: 'EntityState', Text: 'State' },
    { Value: 'Status', Text: 'Status' },
    { Value: 'Franchise', Text: 'Franchise' },
    { Value: 'Brand', Text: 'Brand' }
  ]
  //SearchExper: any[] = [
  //  { Value: 'Contains', Text: 'Contains' },
  //  { Value: 'Exact', Text: 'Exact' },
  //]
  SearchResult: any = [];
  @ViewChild("inputBox") _el: ElementRef;
  @ViewChild("inputBoxtext") _el1: ElementRef;
  RoleID: string;

  constructor(private _CommonService: CommonService, private _EntityService: EntityService, private _router: Router, private Activeroute: ActivatedRoute, public toastr: ToastsManager, vcr: ViewContainerRef,
    private http: Http) {
    this.toastr.setRootViewContainerRef(vcr);
    this.innerWidth = 100;
  }
  ngOnInit() {

    this.ChangeHeadeFooterColor();
    //let val = localStorage.getItem('SearchtextFirst');
    //if (val != null) {
    //  let val2 = "";
    //  this._CommonSearch.SearchQuery = val;
    //  this._EntityService.GetEntitySearchResult(this._CommonSearch).subscribe(res => {
    //    var data = res;
    //    if (!data.Message) {
    //      this.GetEntitySearchAutocomplete = data;
    //      this.loading = false;
    //    }
    //    else {
    //      this.toastr.error(data.Message);
    //      this.loading = false;
    //    }
    //  })
    //}
    this._Entity.SearchdropFirst = "-1";
    this._Entity.SearchdropSecond = "-1";
    this._Entity.SearchMatchesFirst = "Contains";
    this._Entity.SearchMatchesSecond = "Contains";

   
    this._SearchParm = localStorage.getItem('SearchParm');
    if (this._SearchParm != null) {

      this.ResetEntitySearch(this._SearchParm);
    }   
  }
  public GetEntitySearchAutocomplete = (SearchType: any, Searchstring: any): Observable<any[]> => {
   
    if (SearchType) {
      this._CommonSearch.SearchType = SearchType;
      this._CommonSearch.Searchstring = Searchstring;
      let Result = this._CommonService.GetAutoCompleteResult(this._CommonSearch)
      return Result;
    }
    else {
      return Observable.of([]);
    }
  }
  

  FilterFirstChange(Searchdrop: string) {
    this.SearchdropSecond = [];
    this._displaypropertyname1 = Searchdrop;
    let SearchdropFirstdata: any[] = this._Entity.SearchdropSecondList;
    for (let i = 0; i < SearchdropFirstdata.length; i++) {
      if (SearchdropFirstdata[i].Value != Searchdrop) {
        this.SearchdropSecond.push(SearchdropFirstdata[i]);
       
      }
      else {
        this._SelectedText_1 = SearchdropFirstdata[i].Text;
        this.SearchdropFirst.slice(i, 1);
       
      }
    }
    this._Entity.SearchtextFirst = "";
    if (this._Entity.SearchdropFirst == "Status") {
      this._Entity.SearchtextFirst = "Active";
      this._Entity.SearchMatchesFirst = "Contains";
    }
    else {
      this._Entity.SearchMatchesFirst = "Contains";
    }
  }

  public FilterSecondChange(Searchdrop: string) {
    this._displaypropertyname2 = Searchdrop;
    this.SearchdropFirst = [];
    let SearchdropSeconddata: any[] = this._Entity.SearchdropFirstList;
    for (let i = 0; i < SearchdropSeconddata.length; i++) {
      if (SearchdropSeconddata[i].Value != Searchdrop) {
        this.SearchdropFirst.push(SearchdropSeconddata[i]);
        
      }
      else {
        this._SelectedText_2 = SearchdropSeconddata[i].Text;
        this.SearchdropSecond.slice(i, 1);
      }
    }
    this._Entity.SearchtextSecond = "";
    if (this._Entity.SearchdropSecond == "Status") {
      this._Entity.SearchtextSecond = "Active";
      this._Entity.SearchMatchesSecond = "Contains";
    }
    else {
      this._Entity.SearchMatchesFirst = "Contains";
    }
  }

  public BtnSearch() {
    this.loading = true;
    var mQuery: string = "";
    var mQuerysecond: string = "";
    if ((this._Entity.SearchdropFirst != "-1") || (this._Entity.SearchdropSecond != "-1")) {

      let pattern = new RegExp(/^[- a-z. 0-9 _ < > & $ % @ * ~ ! ^ + = : ; , | ( ) ? { } \/ ! # ]+$/i)
      var SearchFirst = true;
      var SearchSecond = true;
      SearchFirst = pattern.test(this._Entity.SearchtextFirst);
      SearchSecond = pattern.test(this._Entity.SearchtextSecond);
      /***********************First Drop Down ****************************************/
      if (this._Entity.SearchdropFirst != "-1") {

        if (this._Entity.SearchtextFirst != undefined && this._Entity.SearchtextFirst != "") {

          if (SearchFirst == true) {
          if (this._Entity.SearchMatchesFirst == "Contains") {
            mQuery = "where " + 'dt.' + this._Entity.SearchdropFirst + ' like ' + "'%" + this._Entity.SearchtextFirst + "%'";
          }
          else if (this._Entity.SearchMatchesFirst == "Exact") {
            mQuery += "where " + 'dt.' + this._Entity.SearchdropFirst + ' = ' + "'" + this._Entity.SearchtextFirst + "'";
            }
          }
          else {
            this.loading = false;
            this.toastr.error("Please enter valid characters in " + this._SelectedText_1 + " search");
            return;
          }
        }
        else {
          /********* ShowWriteToastMessage ******/
         
          this.toastr.error('Please enter the ' + this._SelectedText_1 + '.');
          this.loading = false;
          /********* SetRightToastMessage ******/
         
          return;
        }
      }

      /***********************Second Drop Down ****************************************/
      if (this._Entity.SearchdropSecond != "-1") {

        if (this._Entity.SearchtextSecond != undefined && this._Entity.SearchtextSecond != "") {
          if (SearchSecond == true) {
          if (mQuery == "") {
            mQuery += " where "
          }
          else {
            mQuery += " and "
          }
          
          if (this._Entity.SearchMatchesSecond == "Contains") {
            mQuery += 'dt.' + this._Entity.SearchdropSecond + ' like ' + "'%" + this._Entity.SearchtextSecond + "%'";
          }
          else if (this._Entity.SearchMatchesSecond == "Exact") {
            mQuery += 'dt.' + this._Entity.SearchdropSecond + ' = ' + "'" + this._Entity.SearchtextSecond + "'";
            }
          }
          else {
              this.loading = false;
            this.toastr.error("Please enter valid characters in " + this._SelectedText_2 + " search");
              return;
            }
        }

        else {
          /********* ShowWriteToastMessage ******/
          
          this.toastr.error('Please enter the ' + this._SelectedText_2 + '.');
          this.loading = false;
          /********* SetRightToastMessage ******/
         
          return;
        }
      }
    }
    else {
      this.toastr.error('Please select at least one criteria.');
      this.loading = false;
      return;
    }
    
    this._CommonSearch.SearchQuery = mQuery;
    this._EntityService.GetEntitySearchResult(this._CommonSearch).subscribe(res => {
      var data = res;
      if (data.length > 15) {
        this.tableRowWidth = 100;
      }
      else {
        this.tableRowWidth = 99;
      }
      if (!data.Message) {
        
        this.SearchResult = data;
        this.loading = false;


        let SearchString = [
          { Value: 'First', Text: this._Entity.SearchdropFirst },
          { Value: 'Second', Text: this._Entity.SearchMatchesFirst },
          { Value: 'Third', Text: this._Entity.SearchtextFirst },
          { Value: 'Fourth', Text: this._Entity.SearchdropSecond },
          { Value: 'FiFth', Text: this._Entity.SearchMatchesSecond },
          { Value: 'Sixth', Text: this._Entity.SearchtextSecond }
        ]

        localStorage.setItem('SearchParm', JSON.stringify(SearchString));
        this.setPage(1);

      }
      else {
        this.toastr.error(data.Message);
        this.loading = false;
      }
    })
  }

  get_url: string = '';
  public ChangeHeadeFooterColor() {

    this.get_url = window.location.origin;
    if (this.get_url == "https://localhost:44335") {
      var a = document.getElementById("mainbox");
      a.style.backgroundColor = "#cc4141";

      var footer = document.getElementById("footer");
      footer.style.background = "#cc4141";

      var header = document.getElementById("header");
      header.style.background = "#cc4141";

      // var mnu_Reports = document.getElementsByTagName("ul[_ngcontent-c2] li[_ngcontent-c2]");


    }
    else if (this.get_url == "https://inn-flowmgt-test.azurewebsites.net") {
      var a = document.getElementById("mainbox");
      a.style.backgroundColor = "#cc4141";

      var footer = document.getElementById("footer");
      footer.style.background = "#cc4141";

      var header = document.getElementById("header");
      header.style.background = "#cc4141";

    }
    else if (this.get_url == "https://inn-flowmgt-staging.azurewebsites.net") {
      var a = document.getElementById("mainbox");
      a.style.backgroundColor = "#ed7d31";

      var footer = document.getElementById("footer");
      footer.style.background = "#ed7d31";

      var header = document.getElementById("header");
      header.style.background = "#ed7d31";
    }
  }

  EditOrganizationPage(TenantID: number) {  
    this._router.navigate(['/OrganizationDetails', { TenantID: btoa(JSON.stringify(TenantID)), pageName: btoa(JSON.stringify('EntitySearch')) }]);
  }

  EditEntityPage(TenantID: string, OrgCode: string, EntityID:string) {
    this._router.navigate(['/CreateEntity', { TenantID: btoa(JSON.stringify(TenantID)), OrgCode: btoa(JSON.stringify(OrgCode)), EntityID: btoa(JSON.stringify(EntityID)), pageName: btoa(JSON.stringify('EntitySearch')) }]);

  }

  AddNewEntity() {
    this._router.navigate(['/CreateEntity', { TenantID: btoa(JSON.stringify('-1')), pageName: btoa(JSON.stringify('EntitySearch')) }]);
  }

  ResetEntitySearch(_SearchString:string) {
    let Parm = JSON.parse(_SearchString);
    this._Entity.SearchdropFirst = Parm[0].Text;
    this._Entity.SearchMatchesFirst = Parm[1].Text;
    this._Entity.SearchtextFirst = Parm[2].Text;
    this._Entity.SearchdropSecond = Parm[3].Text;
    this._Entity.SearchMatchesSecond = Parm[4].Text;
    this._Entity.SearchtextSecond = Parm[5].Text;
    this.BtnSearch();
  }
 

 

  public ChangeStatus(Val: string) {
    if (Val == "Inactive") {
      Val = "Terminated";
      return Val;
    }
    else {
      Val = "Active";
      return Val;
    }
  }
  setPage(page: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }

    // get pager object from service
    this.pager = this.getPager(this.SearchResult.length, page);

    // get current page of items
    this.pagedItems = this.SearchResult.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }
  getPager(totalItems: number, currentPage: number = 1, pageSize: number = 10) {
    // calculate total pages
    let totalPages = Math.ceil(totalItems / pageSize);

    let startPage: number, endPage: number;
    if (totalPages <= 10) {
      // less than 10 total pages so show all
      startPage = 1;
      endPage = totalPages;
    } else {
      // more than 10 total pages so calculate start and end pages
      if (currentPage <= 6) {
        startPage = 1;
        endPage = 10;
      } else if (currentPage + 4 >= totalPages) {
        startPage = totalPages - 9;
        endPage = totalPages;
      } else {
        startPage = currentPage - 5;
        endPage = currentPage + 4;
      }
    }

    // calculate start and end item indexes
    let startIndex = (currentPage - 1) * pageSize;
    let endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

    // create an array of pages to ng-repeat in the pager control
    let pages = _.range(startPage, endPage + 1);

    // return object with all pager properties required by the view
    return {
      totalItems: totalItems,
      currentPage: currentPage,
      pageSize: pageSize,
      totalPages: totalPages,
      startPage: startPage,
      endPage: endPage,
      startIndex: startIndex,
      endIndex: endIndex,
      pages: pages
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/Entity/EntitySearch.component.ts